import {
	CatharsisCssResult,
	compCssMappersFeatureWrapper,
	CssFeature,
	getSingleComponentCss,
	stringifySingleComponentCssFromFeatures,
	VSM_CSS_FEATURES,
} from '@wix/thunderbolt-catharsis-extensions'
import { BeckyModel } from '@wix/thunderbolt-becky-root'
import { getDataNodes, getNodesFromFeatures } from './catharsisLoader'
import { ViewerStateManager } from './viewerStateManager'

const createVsm = (beckyModel: BeckyModel) => {
	const compCssMappersFeature = compCssMappersFeatureWrapper(
		beckyModel.componentsMappers,
		(experimentName) => !!beckyModel.experiments[experimentName]
	)
	const features: Record<string, CssFeature<any>> = { ...VSM_CSS_FEATURES, compCssMappers: compCssMappersFeature }
	const { nodes, renderableNodeToFeature } = getNodesFromFeatures(features)
	const vsm = new ViewerStateManager(beckyModel, getDataNodes(), nodes, renderableNodeToFeature)
	return {
		vsm,
		features,
	}
}

export const getViewerStateManagerCss = (beckyModel: BeckyModel) => {
	const { vsm, features } = createVsm(beckyModel)
	const response = vsm.compute()
	// @ts-ignore
	const domApplierProvider = (featureName: string) => features[featureName].domApplier

	let cssString = ''

	const cssObj = Object.values(beckyModel.structure).reduce<CatharsisCssResult>((acc, component) => {
		// @ts-ignore
		acc[component.id] = getSingleComponentCss(
			component,
			// @ts-ignore
			{},
			{},
			// @ts-ignore
			response[component.id],
			domApplierProvider
		)
		cssString += stringifySingleComponentCssFromFeatures(features, acc[component.id])
		return acc
	}, {})

	// @ts-ignore
	return {
		css: cssObj,
		megaStore: {},
		cssResult: cssString,
	}
}
